/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  ActionIcon, ActionIconProps, DetailStack, HStack, ICON_EYE_OUTLINE, UserPreview,
  SimpleTable,
  UserPreviewProps,
} from '@doveit/bricks';
import { Contact } from '../../../providers/api/dtos';
import DateViewer from '../../../components/date-viewer/DateViewer';
import { NO_VALUE_SYMBOL } from '../../../property/utils';
import { HighlightContactDataConfig } from '../../types';
import * as styles from './ContactTableRow.style';
import ViewContactAction from '../../containers/view-contact-action/ViewContactAction';

export interface ContactPreviewTableRowProps {
  contact: Contact,
  padded?: boolean,
  details?: UserPreviewProps['children'],
  primaryAction?: React.ReactElement<ActionIconProps>,
  highlight?: HighlightContactDataConfig,
}

const ContactTableRow: React.FC<ContactPreviewTableRowProps> = ({
  contact,
  padded,
  details,
  primaryAction,
  highlight,
}) => (
  <SimpleTable.Row
    data-testid={`contact-table-row-${contact.id}`}
    aria-label="Informazioni contatto"
    padded={padded}
  >
    <SimpleTable.Cell aria-label="Nome" width="12rem">
      <UserPreview
        name={contact.name || 'Nome assente'}
        size="S"
      >
        {details}
      </UserPreview>
    </SimpleTable.Cell>

    <SimpleTable.Cell aria-label="Numero di telefono">
      <DetailStack label="Telefono" color={highlight?.fields.phoneNumber ? highlight.color : undefined}>
        {contact?.phoneNumber || NO_VALUE_SYMBOL}
      </DetailStack>
    </SimpleTable.Cell>

    <SimpleTable.Cell aria-label="Email">
      <DetailStack
        label="Email"
        color={highlight?.fields.email ? highlight.color : undefined}
      >
        <div css={styles.emailWrapper}>
          {contact?.email || NO_VALUE_SYMBOL}
        </div>
      </DetailStack>
    </SimpleTable.Cell>

    <SimpleTable.Cell aria-label="Data di creazione">
      <DetailStack label="Aggiunto">
        <DateViewer
          stringDate={contact.createdAt!}
          checkIfToday
        />
      </DetailStack>
    </SimpleTable.Cell>

    <SimpleTable.Cell
      aria-label="Azioni"
      align="right"
    >
      <HStack gap={75} wrap="nowrap">
        {primaryAction}
        <ViewContactAction contactId={contact.id!}>
          {({ onClick }) => (
            <ActionIcon
              label="Visualizza"
              aria-label="Visualizza contatto"
              size="S"
              icon={{ path: ICON_EYE_OUTLINE }}
              onClick={onClick}
            />
          )}
        </ViewContactAction>
      </HStack>
    </SimpleTable.Cell>
  </SimpleTable.Row>
);

export default ContactTableRow;
